import {
  OperatorContainsAnyOf,
  OperatorEquals,
  OperatorExactlyAllOf,
  OperatorExactlyAnyOf,
  OperatorExcludeAllOf,
  OperatorExcludeAnyOf,
  OperatorForAllOf,
  OperatorForAnyOf,
  OperatorHasAll,
  OperatorHasAny,
  OperatorIsAllOf,
  OperatorIsAnyOf,
  OperatorIsGreaterThan,
  OperatorIsLessThan,
  OperatorIsNotAnyOf,
  OperatorIsNotPresent,
  OperatorIsPresent,
  OperatorNot,
  OperatorNotEquals,
} from 'v2/core/services/queryBuilder/operators';

export const MULTI_VALUE_OPERATORS = [
  OperatorExactlyAllOf,
  OperatorExactlyAnyOf,
  OperatorExcludeAllOf,
  OperatorExcludeAnyOf,
  OperatorForAllOf,
  OperatorForAnyOf,
  OperatorHasAll,
  OperatorIsAnyOf,
  OperatorIsAllOf,
  OperatorHasAny,
  OperatorEquals,
  OperatorNotEquals,
  OperatorNot,
  OperatorIsNotAnyOf,
  OperatorContainsAnyOf,
];

export const NO_VALUE_OPERATORS = [OperatorIsNotPresent, OperatorIsPresent];

export const USER_SINGLE_VALUE_INPUT_OPERATORS = [
  OperatorIsGreaterThan,
  OperatorIsLessThan,
];

export const IS_QB_MODAL_CLOSED_KEY = 'IS_QB_MODAL_CLOSED_KEY';
